export enum CampaignFirebaseName {
  ticket = 'ticket',
  fenerium = 'fenerium',
}
